export default "__VITE_ASSET__CC8s6mZx__"